import { render, staticRenderFns } from "./SearchNotificationsHeader.vue?vue&type=template&id=cc5166f0&"
import script from "./SearchNotificationsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchNotificationsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchNotificationsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports